<!-- ==========================================================================
     GESTIÓN DE USUARIOS / SCRATCHCARDS
     ========================================================================== -->

<div class="container-fluid assignment-page">

    <div class="assignment-container">

        <div class="assignment-content">

            <!-- ==================================================================
                 01. ENCABEZADO
                 ================================================================== -->

            <div class="assignment-header">

                <div class="assignment-header-content">

                    <div class="assignment-header-icon">
                        <i class="fa-solid fa-user-plus"></i>
                    </div>

                    <div class="assignment-header-text">

                        <h4>
                            Asignación de usuarios
                        </h4>

                        <p>
                            Busca un usuario, selecciona un Scratchcard disponible
                            y asígnalo.
                        </p>

                    </div>

                </div>

            </div>


            <!-- ==================================================================
                 02. ASIGNAR USUARIO
                 ================================================================== -->

            <div class="assignment-section">

                <!-- HEADER -->

                <div class="assignment-section-header">

                    <h5>
                        Asignar usuario
                    </h5>

                    <p>
                        Busca el usuario y selecciona el Scratchcard que deseas asociar.
                    </p>

                </div>


                <!-- ==============================================================
                     CONTROLES
                     ============================================================== -->

                <div class="assignment-controls">


                    <!-- ==========================================================
                         BUSCAR USUARIO
                         ========================================================== -->

                    <div class="assignment-field assignment-user-field">

                        <label class="form-label">
                            Buscar usuario
                        </label>


                        <div class="autocomplete-wrapper">

                            <app-search-autocomplete
                                [searchFunction]="search"
                                [displayKey]="'nombre'"
                                [secondaryDisplayKey]="'correo'"
                                [placeholder]="'Buscar por: correo'"
                                [minLength]="3"
                                [debounceTimeMs]="500"
                                (itemSelected)="selectItem($event)">
                            </app-search-autocomplete>

                        </div>


                        <span class="assignment-help">
                            Escribe al menos 3 caracteres para buscar.
                        </span>

                    </div>


                    <!-- ==========================================================
                         SCRATCHCARD
                         ========================================================== -->

                    <div class="assignment-field assignment-scratch-field">

                        <label class="form-label">
                            Scratchcard
                        </label>


                        <div class="scratchcard-select-wrapper">

                            <!-- ICONO -->

                            <span class="scratchcard-icon">
                                <i class="fa-solid fa-id-card"></i>
                            </span>


                            <!-- SELECT -->

                            <select
                                class="form-select scratchcard-select"
                                [(ngModel)]="selectedScratchcard">

                                <option [ngValue]="null">
                                    Seleccione un Scratchcard
                                </option>


                                <option
                                    *ngFor="let item of currentItemsScratch"
                                    [ngValue]="item">

                                    {{ item.nombre }} - {{ item.scratchcard }}

                                </option>

                            </select>


                            <!-- LOADING -->

                            <div
                                *ngIf="spinnerSelect"
                                class="scratchcard-loading">

                                <span
                                    class="spinner-border spinner-border-sm">
                                </span>

                            </div>

                        </div>


                        <!-- TEXTO AYUDA -->

                        <span
                            class="assignment-help"
                            *ngIf="!spinnerSelect">

                            Selecciona uno de los Scratchcards disponibles.

                        </span>


                        <span
                            class="assignment-help loading"
                            *ngIf="spinnerSelect">

                            Cargando Scratchcards disponibles...

                        </span>

                    </div>


                    <!-- ==========================================================
                         BOTÓN ASIGNAR
                         ========================================================== -->

                    <div class="assignment-button-column">

                        <button
                            type="button"
                            class="assignment-btn"
                            [disabled]="!selectedScratchcard"
                            (click)="asignarUsuarioGrupo()">

                            <i class="fa-solid fa-user-check"></i>

                            <span>
                                Asignar
                            </span>

                        </button>

                    </div>

                </div>

            </div>


            <!-- ==================================================================
                 03. DIVISOR
                 ================================================================== -->

            <div class="assignment-divider"></div>


            <!-- ==================================================================
                 04. USUARIOS ASIGNADOS
                 ================================================================== -->

            <div class="users-section">


                <!-- ==============================================================
                     HEADER
                     ============================================================== -->

                <div class="users-section-header">

                    <div class="users-section-title">

                        <h5>
                            Usuarios asignados
                        </h5>

                        <p>
                            Consulta y administra los usuarios actualmente asignados.
                        </p>

                    </div>


                    <!-- ==========================================================
                         BUSCADOR
                         ========================================================== -->

                    <form
                        [formGroup]="searchForm"
                        class="users-search-form">

                        <div class="users-search">

                            <span class="users-search-icon">
                                <i class="fa-solid fa-magnifying-glass"></i>
                            </span>


                            <input
                                type="text"
                                class="form-control"
                                placeholder="Buscar por correo"
                                formControlName="search">


                            <button
                                type="button"
                                class="users-search-btn"
                                (click)="getUserGroup()"
                                aria-label="Buscar">

                                <i class="fa-solid fa-arrow-right"></i>

                            </button>

                        </div>

                    </form>

                </div>


                <!-- ==============================================================
                     TABLA
                     ============================================================== -->

                <div class="assignment-table">

                    <app-paginacion
                        [currentPage]="currentPage"
                        [totalItems]="totalItems"
                        [selectedPageSize]="pageSize"
                        [paginatedData]="currentItems"
                        [headers]="tableHeaders"
                        [actions]="customActions"
                        (pageChange)="onPageChange($event)"
                        (pageSizeChange)="onPageSizeChange($event)"
                        [loading]="spinner">
                    </app-paginacion>

                </div>

            </div>

        </div>

    </div>

</div>